import { useState } from 'react';
import { OrgManager } from './OrgManager';
import { UserManager } from './UserManager';
import { AuditLog } from './AuditLog';

const FONT = "'JetBrains Mono', 'Fira Code', monospace";

type Tab = 'orgs' | 'users' | 'audit';

export function AdminConsole() {
  const [tab, setTab] = useState<Tab>('orgs');

  const tabs: { id: Tab; label: string }[] = [
    { id: 'orgs', label: 'Organizations' },
    { id: 'users', label: 'Users' },
    { id: 'audit', label: 'Audit Log' },
  ];

  return (
    <div style={{
      padding: 24,
      fontFamily: FONT,
      color: '#f8f8f2',
      minHeight: '100%',
    }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{
          fontSize: 20, fontWeight: 700, color: '#f8f8f2',
          margin: '0 0 4px', fontFamily: FONT,
        }}>
          Admin Console
        </h1>
        <p style={{ fontSize: 11, color: '#6272a4', margin: 0 }}>
          Platform administration and organization management
        </p>
      </div>

      {/* Tab bar — OS window tabs */}
      <div style={{
        display: 'flex', gap: 0,
        background: '#1a1b26',
        borderRadius: '8px 8px 0 0',
        border: '1px solid rgba(255,255,255,0.06)',
        borderBottom: 'none',
        overflow: 'hidden',
      }}>
        {tabs.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              padding: '10px 24px',
              background: tab === t.id ? '#1e1e2e' : 'transparent',
              border: 'none',
              borderRight: '1px solid rgba(255,255,255,0.06)',
              borderBottom: tab === t.id ? '2px solid #50fa7b' : '2px solid transparent',
              color: tab === t.id ? '#50fa7b' : '#6272a4',
              fontSize: 13,
              fontFamily: FONT,
              fontWeight: tab === t.id ? 600 : 400,
              cursor: 'pointer',
              transition: 'all 0.15s ease',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Tab content panel */}
      <div style={{
        background: '#1e1e2e',
        border: '1px solid rgba(255,255,255,0.06)',
        borderTop: 'none',
        borderRadius: '0 0 8px 8px',
        padding: 24,
      }}>
        {tab === 'orgs' && <OrgManager />}
        {tab === 'users' && <UserManager />}
        {tab === 'audit' && <AuditLog />}
      </div>
    </div>
  );
}
